import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
} from "../../../../../../shared/components/card/Card";
import { formatToEurosCurrency } from "../../../../../../shared/lib/utils";
import CreatePeriodDialog from "../create-period/CreatePeriodDialog";
import EditObjectiveTrackerDialog from "../edit/EditObjectiveTrackerDialog";
import ObjectivesTrackerDeleteButton from "./ObjectivesTrackerDeleteButton";

const ObjectivesTrackerDetail = ({
  tracker,
  onPeriodCreation,
  onTrackerEdition,
  onTrackerDeletion,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex flex-row pl-1 gap-x-2">
        <div className="font-medium text-3xl">
          {tracker?.client?.name} - ({tracker?.client?.code})
        </div>
        <div className="text-3xl">: {tracker?.name}</div>
      </div>
      <Card>
        <CardContent className="p-1">
          <div className="flex flex-row justify-between items-center">
            <div className="flex flex-col ml-4">
              <div>
                {t("objectivesTracker.detail.beginDateLabel")}:{" "}
                {tracker?.beginDate}
              </div>
              <div>
                {t("objectivesTracker.detail.endDateLabel")}: {tracker?.endDate}
              </div>
            </div>
            <div>
              {t("objectivesTracker.detail.objectiveLabel")}:{" "}
              {formatToEurosCurrency(tracker?.result?.goal)}
            </div>
            <div>
              {t("objectivesTracker.detail.achievedLabel")} :{" "}
              {formatToEurosCurrency(tracker?.result?.achieved)}
            </div>
            <div>
              {t("objectivesTracker.detail.expectedLabel")} :{" "}
              {formatToEurosCurrency(tracker?.result?.expected)}
            </div>
            <div>
              {t("objectivesTracker.detail.differenceLabel")}:{" "}
              {formatToEurosCurrency(tracker?.result?.difference)}
            </div>
            <div className="flex flex-row gap-x-1">
              <CreatePeriodDialog
                onSubmitHandler={onPeriodCreation}
                trackerGoal={tracker?.result?.goal}
              />
              <EditObjectiveTrackerDialog
                onSubmitHandler={onTrackerEdition}
                tracker={tracker}
              />
              <ObjectivesTrackerDeleteButton
                onDeleteHandler={onTrackerDeletion}
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ObjectivesTrackerDetail;
